export default {_name:'grid.form.section',module:'Card/Form',view:'Element/Section',options:{component:'section',xs:12,ms:12,block:{xs:'auto',ms:'auto'}}}